class Dropdown extends HTMLElement {
    constructor() {
        super();
        this.eventListeners();
        this.openSelectedDropdowns();
    }

    eventListeners() {
        const { trigger } = this.dropdownComponents();

        for(let i=0; i < trigger.length; i++) {
            trigger[i].addEventListener('click', (e) => {
                // this.closeAllDropdowns();
                this.toggleDropdown(e.currentTarget.nextElementSibling);
            })
        }

    }

    //Toggle dropdown element in navigation container
    toggleDropdown(dropdownContent) {
        const dropdownHeader = {
            title: this.querySelector('.dropdown-trigger h1'),
            arrow: this.querySelector('.toggle-arrow'),
        }
    
        if(dropdownContent.classList.contains('twcss-hidden')) {
            dropdownContent.classList.remove('twcss-hidden');

            if(dropdownHeader.title.classList.contains('twcss-text-white')) {
                dropdownHeader.arrow.classList.replace('twcss-text-white', 'twcss-text-red');
                dropdownHeader.title.classList.replace('twcss-text-white', 'twcss-text-red');
            } else {
                dropdownHeader.arrow.classList.replace('twcss-text-black', 'twcss-text-red');
                dropdownHeader.title.classList.replace('twcss-text-black', 'twcss-text-red');
            }

            dropdownHeader.arrow.classList.replace('twcss-rotate-0', 'twcss-rotate-180');
    
        } else {
            dropdownContent.classList.replace('twcss-animate-dropdown-in', 'twcss-animate-dropdown-out');
            setTimeout(() => {
                dropdownContent.classList.add('twcss-hidden');
                dropdownContent.classList.replace('twcss-animate-dropdown-out', 'twcss-animate-dropdown-in');

                if(dropdownContent.querySelector('article').classList.contains('twcss-text-white')) {
                    dropdownHeader.title.classList.replace('twcss-text-red', 'twcss-text-white');
                    dropdownHeader.arrow.classList.replace('twcss-text-red', 'twcss-text-white');
                } else {
                    dropdownHeader.title.classList.replace('twcss-text-red', 'twcss-text-black');
                    dropdownHeader.arrow.classList.replace('twcss-text-red', 'twcss-text-black');
                }

                dropdownHeader.arrow.classList.replace('twcss-rotate-180', 'twcss-rotate-0');
            }, 300)

        }        
    }

    openSelectedDropdowns() {
        const { dropdownsOpen } = this.dropdownComponents();

        dropdownsOpen.forEach(dropdown => {
            this.toggleDropdown(dropdown.nextElementSibling);
        })
    }

    closeAllDropdowns() {
        const { trigger } = this.dropdownComponents();

        for(let i=0; i < trigger.length; i++) {
            trigger[i].nextElementSibling.classList.add('hidden');
            trigger[i].querySelector('.toggle-arrow').classList.replace('twcss-rotate-180', 'twcss-rotate-0');
        }
    }

    dropdownComponents() {
        const trigger = this.getElementsByClassName('dropdown-trigger');
        const dropdownsOpen = this.querySelectorAll('.dropdown-open');

        return { trigger, dropdownsOpen }
    }
}

customElements.define('dropdown-elements', Dropdown);
